export const OPPORTUNITY_PATH = "/opportunities/:id?";
